export default async (team, company) => {

    const url = `${process.env.REACT_APP_REST_API_URL}/company/teams/${company}`
    let fetchedData = {message:null,data:null};
    console.log("POSTING")
    const fetchOptions = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(team)
    };

    try {
        await fetch(url, fetchOptions).
        then(response => response.json()).
        then(data => fetchedData = data)
    } catch(err) {
        console.error(err)
        fetchedData = err
    }
    return fetchedData

}   